'use strict';

require('picturefill');

require('focus-visible');

require('element-closest');

/**
 * 'startsWith' polyfill.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith#Polyfill
 */
document.addEventListener('DOMContentLoaded', function () {

  if (!String.prototype.startsWith) {

    String.prototype.startsWith = function (searchString, position) {

      position = position || 0;
      return this.substr(position, searchString.length) === searchString;
    };
  }
});

/**
 * 'assign' polyfill.
 * https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Polyfill
 */
/**
 * Few polyfills we need on any of web applications at Flightright.
 * These bring methods and/or features that a few browser we need to support do
 * not support yet.
 */

if (typeof Object.assign !== 'function') {

  Object.assign = function (target) {

    if (target === null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }

    target = Object(target);

    for (var index = 1; index < arguments.length; index++) {

      var source = arguments[index];

      if (source !== null) {

        for (var key in source) {

          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
    }
    return target;
  };
}